import { CitySettings } from '@/types/productSettingTypes';
import { Component, Vue} from 'vue-property-decorator';
import locations from "@/settings/city";
import WithRender from  './City.html';

@WithRender
@Component({
 })
export default class City extends Vue {
    
    locations = {} as string[];
    selectedLocation='Bulawayo';
    CitySettings = {} as CitySettings;
    isoCountry = "";
    portiFolio = "";

    mounted()
    {
        this.CitySettings = locations;
        this.isoCountry = this.$route.query.c as string;
        this.portiFolio = this.$route.query.portiFolio as string 
        this.locations = this.CitySettings.cities.filter(x=>x.isoCountry == this.isoCountry)[0].city;       
    }
    async proceed(){
       await this.$store.dispatch("productGridStore/reset");
       this.$router.push({name:'productGrid', query:{c:this.isoCountry, portiFolio: this.portiFolio, l: this.selectedLocation }})
    }

}
